module.exports = __webpack_public_path__ + "img/a6.111e825d.jpeg";